import React from 'react';

//PACKS
import { connect } from 'react-redux';
import { Button, Alert, Navbar, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm } from 'react-final-form';
import { UserPin } from '@styled-icons/boxicons-regular/UserPin';

//Components
import FormValidaCadastro from '../../../components/forms/logins/FormValidaCadastro';

//ACTIONS
import { validacacadastro, codigovalidacacadastro } from '../../../actions/login/login';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

class ValidaCadastro extends React.Component {
        
    onSubmit = async (form) => {
        const forms = {
            idpromotora: this.props.idpromotora,
            ...form
        }

        const response = await this.props.validacacadastro(forms);
        console.log(response);
        if(response&&response.result === true){
            setTimeout(() => {
                this.form.reset();
            }, 500);
        }
    }

    handleEnviaCodigo = () => {

        const dados = {
            idpromotora: this.props.idpromotora,
            email: 'marcus.vinicius@cidtech.com.br'
        }

        this.props.codigovalidacacadastro(dados);
    }

    render(){
                        
        return (
            <FinalForm 
            onSubmit={this.onSubmit}
            validate={ values => {
                const errors = {};
                if(!values.email){
                    errors.email = trad(this.props.trads,'ERROEMAIL1',this.props.lingua);
                }

                if(!values.codigo){
                    errors.codigo = trad(this.props.trads,'OBRIGATORIO',this.props.lingua);
                }                
                return errors;
            }}
            render={({form, pristine, submitting, handleSubmit}) => {
            this.form = form;
            return(
                <form onSubmit={handleSubmit}>
                    <Navbar bg="light" expand="lg" className="justify-content-center">
                        <Navbar.Brand>{trad(this.props.trads,'Validação de Cadastro, Informe o e-mail e o código recebido',this.props.lingua)}</Navbar.Brand>
                        <UserPin size="60" />
                    </Navbar>
                    {
                    this.props.validacaocad&&this.props.validacaocad.result===false?
                    <Alert variant="warning">Dados Incorretos!</Alert>
                    :
                    this.props.validacaocad&&this.props.validacaocad.result===true?
                    <Alert variant="success">Validado com sucesso!</Alert>
                    :
                    null
                    }
                    <FormValidaCadastro 
                    form={form}
                    {...this.props}                    
                    />
                    <Button          
                        id="btosubmit"               
                        variant="primary" 
                        size="lg" 
                        block 
                        type="submit"       
                        onClick={this.handleSubmitLog}
                        disabled={submitting || pristine}
                        >
                        {this.props.pendingTasks?
                        <Spinner animation="border"  />
                        :
                        trad(this.props.trads,'BT_AVANCAR2',this.props.lingua)
                        }
                    </Button>
                    <Button
                        variant="secondary" 
                        size="lg" 
                        block 
                        type="button"       
                        onClick={this.props.handleVoltar}                        
                        >
                        {trad(this.props.trads,'Voltar',this.props.lingua)}
                    </Button>
                    <Button
                        variant="secondary" 
                        size="lg" 
                        block 
                        type="button"       
                        onClick={this.handleEnviaCodigo}
                        >
                        {trad(this.props.trads,'Enviar Email',this.props.lingua)}
                    </Button>
                </form>
                )
            }}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        trads: state.reducerTraducoes,
        pendingTasks: state.pendingTasks,
        validacaocad: state.validaCadReducer
    }
}

export default connect(mapStateToProps,{validacacadastro, codigovalidacacadastro})(withRouter(ValidaCadastro));